import Typography, { type TypographyProps } from "@mui/material/Typography";

/** The brand/hero title, e.g. the landing page wordmark. Renders as an `<h1>`. */
export function BrandTitle(props: TypographyProps) {
  return <Typography variant="h2" component="h1" fontWeight={600} color="primary" {...props} />;
}
